import React, { useState } from "react";
import cybersiara from "../../images/home/client/cybersiara.svg";
import kesari from "../../images/home/client/kesari.svg";
import mPrompto from "../../images/home/client/m-Prompto.svg";
import Finovia from "../../images/home/client/finovia.svg";
const clientData = [
  {
    id: 1,
    images: kesari,
    qoute: "Thanks to their team, our travel platform is faster, smoother, and ready for global scale. Truly dependable tech partners!"
  },
  {
    id: 2,
    images: mPrompto,
    qoute: "Their team brought our complex idea to life with precision and speed. A powerhouse of tech expertise!"
  },
  {
    id: 3,
    images: Finovia,
    qoute:
      "We are proud to say that Shine Infosoft has highly skilled resources who can help you out to see unseen technology gaps in your existing project and achieve the deliverables before time.",
  },
  {
    id: 4,
    images: cybersiara,
    qoute:
      "Since the beginning of our prestigious project CyberSIARA, the skilled resources from Shine Infosoft have helped us a lot. We believe that it was difficult to achieve desires without expertise from Shine Infosoft Developers.",
  },
];

const Testimonial = () => {
  const [submanuId, setSubmanuId] = useState(1);

  return (
    <>
      <section className="clientReviewSection">
        <div className="container">
          <div className="row">
            <div className="col-md-7 col-sm-7 ml-auto">
              <div className="text" data-aos="slide-down">
                <p>
                  {clientData
                    .filter((f) => f.id === submanuId)
                    .map((each, i) => (
                      <span key={i}>{each.qoute}</span>
                    ))}
                </p>
              </div>
              <div className="row clientLogo">
                {clientData.map((m) => (
                  <div
                    className="col-md-3 col-sm-6 col-12 mb-0 mb-sm-4"
                    data-aos="zoom-in"
                    key={m.id}
                  >
                    <div
                      className={`logos ${submanuId === m.id ? "active" : ""}`}
                      onClick={() => setSubmanuId(m.id)}
                    >
                      <img src={m.images} alt="Hire VueJS Developers" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
